import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { upsertSubmissionToDB } from 'util/submission'
import { upsertPodcast } from 'util/podcast'
import { Podcast, Submission } from 'lib/types/generated-types'

interface PodcastFormStepsStoreProps {
  setOwner: (ownerId: string) => void
  submission: Partial<Submission>
  updateSubmission: (submission: Partial<Submission>) => Promise<Submission>
  podcast: Partial<Podcast>
  updatePodcast: (podcast: Partial<Podcast>) => Promise<Podcast>
  currentStepIndex: number
  setCurrentStepIndex: (step: number) => void
  resetState: () => void
}

const usePodcastFormStepsStore = create(
  immer<PodcastFormStepsStoreProps>((set) => ({
    resetState: () => {
      set((state) => {
        state.submission = {
          status: 'pending',
        }
        state.podcast = {}
        state.currentStepIndex = 0
      })
    },
    setOwner: (ownerId) => {
      set((state) => {
        state.submission.owner = ownerId
        state.podcast.owner = ownerId
      })
    },
    submission: {
      status: 'pending',
    },
    updateSubmission: async (submission): Promise<Submission> => {
      try {
        const upsertedSubmission = await upsertSubmissionToDB(submission)
        set((state) => {
          state.submission = {
            ...state.submission,
            ...upsertedSubmission,
          }
        })
        return upsertedSubmission
      } catch (error) {
        console.error('Error adding submission:', error.message)
        throw new Error(error.message)
      }
    },
    podcast: {},
    updatePodcast: async (podcast) => {
      try {
        const updatedPodcast = await upsertPodcast(podcast)
        set((state) => {
          state.podcast = {
            ...state.podcast,
            ...updatedPodcast,
          }
        })
        return updatedPodcast
      } catch (error) {
        console.error('Error upserting podcast:', error.message)
        throw new Error(error.message)
      }
    },
    currentStepIndex: 0,
    setCurrentStepIndex: (step) => {
      set((state) => {
        state.currentStepIndex = step
      })
    },
  }))
)

export default usePodcastFormStepsStore
